export class NodeViewModel {
    id: string;
    name:string;
    descriptor: string;
    nodeColor:string ;
    farmtypeid: number;
    farmtypename: string;
    nodeboxtypeid: number;
    nodeboxtypename: string;
    sourcenodelink: LinkNodeViewModel[];
    targetnodelink: LinkNodeViewModel[];
    rcNo: string ;
    configGuid: string;
    refineryConfigGuid: string;
    refineryConfigId: number;
    refineryConfigName: string;
    iconpath: string;
    ingesticonpath: string;
    processoriconpath: string;

    constructor(id: string, name: string, descriptor: string, nodeColor:string, farmtypeid: number, farmtypename: string, nodeboxtypeid: number, nodeboxtypename: string,sourcenodelink: LinkNodeViewModel[],targetnodelink: LinkNodeViewModel[],rcNo: string,configGuid: string,refineryConfigGuid: string,refineryConfigId: number,refineryConfigName: string,iconpath: string,ingesticonpath:string,processoriconpath: string) {
        this.id = id;
        this.descriptor= descriptor;
        this.nodeColor= nodeColor;
        this.name= name;
        this.farmtypeid= farmtypeid;
        this.farmtypename= farmtypename;
        this.nodeboxtypeid= nodeboxtypeid;
        this.nodeboxtypename= nodeboxtypename;
        this.sourcenodelink= sourcenodelink; 
        this.targetnodelink= targetnodelink;
        this.rcNo = rcNo;
        this.configGuid = configGuid;
        this.refineryConfigGuid = refineryConfigGuid;
        this.refineryConfigId = refineryConfigId;
        this.refineryConfigName = refineryConfigName;
        this.iconpath = iconpath;
        this.ingesticonpath = ingesticonpath;
        this.processoriconpath = processoriconpath;
    }
}
export class LinkNodeViewModel {
    linkid: string;
    nodeid: string;
    name: string;
    farmtypeid: string;
    farmtypename: string;
	linetype: string;
    constructor(linkid: string,nodeid: string,name: string,farmtypeid: string,farmtypename: string,linetype: string) {
        this.linkid = linkid;
        this.nodeid= nodeid;
        this.name= name;
        this.farmtypeid= farmtypeid;
        this.farmtypename= farmtypename;
        this.linetype= linetype;
    }
}
